import React, { useState } from 'react';
import Modal from './DetallesModal';

const Productos = ({ productsItem, newAddProduct }) => {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleViewDetails = (products) => {
    setSelectedProduct(products);
  };

  const closeModal = () => {
    setSelectedProduct(null);
  };

  return (
    <div className='products'>
      {productsItem.map((products) => (
        <div key={products.id} className="card" style={{ width: '15rem' }}>
          <div className='card-img-grid-1'>
            <img src={products.img} className="card-img" alt={products.name} />
          </div>
          <div className="card-body">
            <h6 className="card-title">{products.name}</h6>
            <p className="card-text">$ {products.price}</p>
          </div>
          <div className='card-img-grid-3'>
            <button className="button-addCart" onClick={() => handleViewDetails(products)}>
              Ver detalles
            </button>
          </div>
        </div>
      ))}

      {selectedProduct && (
        <Modal
          products={selectedProduct}
          newAddProduct={newAddProduct}
          onClose={closeModal}
        />
      )}
    </div>
  );
};

export default Productos;
